module.exports = __webpack_public_path__ + "images/category_lp/common/search_bc7df0224755c8662dd2aecd8998340f.png";